import script from "./GeneralSetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./GeneralSetting.vue?vue&type=script&setup=true&lang=ts"

import "./GeneralSetting.vue?vue&type=style&index=0&id=19132193&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19132193"]])

export default __exports__